"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Storage wrapping class for presenting symmetric usage of storage functions.
 * @class StorageService
 */
class StorageService {
    constructor(store) {
        this.store = store;
    }
    /**
     * Store a value against the given key.
     * @param key
     * @param value
     */
    setItem(key, value) {
        return this.wrapOperation(() => this.store.setItem(key, value));
    }
    /**
     * Gets the value for the given key.
     * @param key
     */
    getItem(key) {
        return this.wrapOperation(() => this.store.getItem(key));
    }
    /**
     * Remove a value for the given key.
     * @param key
     */
    removeItem(key) {
        return this.wrapOperation(() => this.store.removeItem(key));
    }
    wrapOperation(func) {
        try {
            const result = func();
            if (result instanceof Promise) {
                return result;
            }
            else {
                return Promise.resolve(result);
            }
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
}
exports.StorageService = StorageService;
